

























































import { defineComponent, ref } from '@vue/composition-api';
import { useQrcode } from './use-qrcode';

export default defineComponent({
    name: 'auth-confirm',
    props: {
        qrType: {
            type: String,
            default: '',
        },
        tips: {
            type: String,
            default: '请使用开发者账号下的管理员快手ID扫码进行验证',
        },
        title: {
            type: String,
            default: '身份确认',
        },
    },
    setup(props, { emit }) {
        const visible = ref(false);
        let resolve: (token: string) => void;
        let reject: () => void;
        const config = {
            qrType: props.qrType,
            serviceOwnParams: {},
            onOk: (e: string) => {
                visible.value = false;
                resolve(e);
                emit('success', e);
            },
        };
        const status = useQrcode(config);

        const startAuth = (serviceOwnParams: Record<string, any>) => {
            config.serviceOwnParams = serviceOwnParams;
            visible.value = true;
            status.refresh();
            return new Promise<string>((res, rej) => {
                resolve = res;
                reject = rej;
            });
        };

        return Object.assign(status, {
            closeAuth() {
                visible.value = false;
                status.cancelScan();
                emit('cancel');
                reject();
            },
            visible,
            startAuth,
        });
    },
});
